import { useEffect, useState } from 'react';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import { CheckCircle2, Download, ArrowRight, Package2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import confetti from 'canvas-confetti';

export default function DesignThankYou() {
  const { designId } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [celebrated, setCelebrated] = useState(false);

  useEffect(() => {
    if (!celebrated) {
      confetti({
        particleCount: 150,
        spread: 100,
        origin: { y: 0.6 },
        colors: ['#F43F5E', '#FBBF24', '#34D399']
      });
      setCelebrated(true);
    }
  }, [celebrated]);

  return (
    <div className="min-h-screen bg-background">
      <nav className="bg-white/80 backdrop-blur-md border-b border-stone-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex justify-between items-center">
          <div className="flex items-center space-x-2 cursor-pointer" onClick={() => navigate('/')}>
            <Package2 className="h-8 w-8 text-primary" />
            <h1 className="text-2xl font-heading font-extrabold text-foreground tracking-tight">Even Rounds</h1>
          </div>
        </div>
      </nav>

      <main className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="rounded-3xl bg-white border border-stone-100 p-12 text-center shadow-lg">
          <div className="inline-flex items-center justify-center h-24 w-24 rounded-full bg-gradient-to-br from-green-100 to-emerald-100 mb-6">
            <CheckCircle2 className="h-16 w-16 text-green-600" />
          </div>
          
          <h1 className="text-3xl md:text-4xl font-heading font-extrabold tracking-tight mb-4">
            Thank You for Your Purchase! 🎉
          </h1>
          
          <p className="text-lg text-muted-foreground mb-8">
            Your payment was successful! You now have full access to this crochet pattern, 
            including the PDF download and detailed instructions.
          </p>

          <div className="rounded-2xl bg-green-50 border border-green-100 p-6 mb-8">
            <p className="text-sm text-green-700">
              <strong>A confirmation email</strong> has been sent to your email address with download links.
              You can also access your purchase anytime by entering your email on the design page.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              onClick={() => navigate(`/designs/${designId}`)}
              className="rounded-full bg-primary text-primary-foreground shadow-lg shadow-primary/30 hover:shadow-primary/50 transition-all font-bold"
            >
              <Download className="h-5 w-5 mr-2" />
              View Pattern & Download
            </Button>
            <Button
              onClick={() => navigate('/designs')}
              variant="outline"
              className="rounded-full"
            >
              Browse More Designs
              <ArrowRight className="h-5 w-5 ml-2" />
            </Button>
          </div>
        </div>

        <div className="mt-8 text-center">
          <p className="text-sm text-muted-foreground">
            Questions about your purchase? Contact us at{' '}
            <a href="mailto:support@evenrounds.com" className="text-primary hover:underline">
              support@evenrounds.com
            </a>
          </p>
        </div>
      </main>
    </div>
  );
}
